import React from 'react';
import { useCorrectionModalContext } from './CorrectionModalContext';
import useCorrectionModal from '@/finsight/ui/components/deals/CorrectionModal/useCorrectionModal';
import IconPencil from '@dealroadshow/uikit/core/components/Icon/IconPencil';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';

import styles from '@/finsight/ui/components/deals/DealsList/DealHeader/dealHeader.scss';

interface IProps {
  selectedDeal: any,
}

const CorrectionButton = ({ selectedDeal }: IProps) => {
  const {
    isCorrectionModalVisible,
    showCorrectionModal,
    hideCorrectionModal,
    CorrectionModal,
  } = useCorrectionModal();

  const {
    setSelectedDeal,
    resetCorrectionForm,
    isFetching,
    isSubmitSucceed,
    sendCorrectionData,
  } = useCorrectionModalContext();

  const getDealName = (deal): string => {
    if (!deal) {
      return '';
    }

    return `${ deal.primaryIssuer.name } (${ deal.primaryIssuer.issuerTicker }) ${ deal.seriesName }`;
  };

  const handleCorrectionModal = (event) => {
    event.stopPropagation();

    if (isCorrectionModalVisible) {
      hideCorrectionModal();
    } else {
      showCorrectionModal();
      setSelectedDeal(selectedDeal);
    }
  };

  return (
    <>
      <div className={ styles.tool }>
        <div className={ styles.correctionBtn }>
          <Tooltip content="Submit a Correction">
            <IconPencil
              data-test="submitCorrection"
              onClick={ handleCorrectionModal }
            />
          </Tooltip>
        </div>
      </div>
      <CorrectionModal
        isFetching={ isFetching }
        isSubmitSucceed={ isSubmitSucceed }
        hideModal={ hideCorrectionModal }
        resetModal={ resetCorrectionForm }
        submitForm={ sendCorrectionData }
        isVisible={ isCorrectionModalVisible }
        deal={ {
          id: selectedDeal.id,
          name: getDealName(selectedDeal),
        } }
      />
    </>
  );
};

export default CorrectionButton;
